<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card no-body>
            <div v-if="loadingProcess" class="loading-steps">
              <div v-for="step in loadingSteps" :key="step.key">
                <span v-if="step.done">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5 13l4 4L19 7"
                      stroke="currentColor"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"/>
                  </svg>
                </span>
                <span v-else>
                      <svg width="20" height="20" viewBox="0 0 50 50">
                      <circle
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="5"
                        stroke-linecap="round"
                        stroke-dasharray="31.4 31.4">
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 25 25"
                          to="360 25 25"
                          dur="1s"
                          repeatCount="indefinite" />
                      </circle>
                    </svg>
                </span>
                {{ step.label }}
              </div>
            </div>
            <div v-else>

          <b-card-header>
            <i class="icon-list"></i>
            Orçamento
            <b-button
              v-if="podeImprimirOrcamento"
              v-on:click="printOrcamento"
              size="sm"
              class="float-right"
              variant="primary"
            >
              <i class="fa fa-print"></i> Imprimir Proposta
            </b-button>

            <b-button
              v-on:click="duplicarOrcamento"
              size="sm"
              class="float-right mr-3"
              variant="primary"
            >
              <i class="fa fa-copy"></i> Duplicar Orçamento
            </b-button>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col md="2">
                <b-form-group label="Código" label-for="id">
                  <b-form-input
                    id="id"
                    type="text"
                    :value="$store.state.orcamento.dados.id"
                    placeholder="Código"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="1">
                <b-form-group
                  v-if="clientStatus != null"
                  label="Status"
                  label-for="status"
                >
                  <h3>
                    <orcamento-status id="status" :status="orcamentoStatus" />
                  </h3>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Data de Emissão" label-for="data_emissao">
                  <b-form-input
                    id="data_emissao"
                    type="text"
                    :value="$store.state.orcamento.dados.data_emissao | formatDate"
                    placeholder="Data de Emissão"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Data de Validade"
                  label-for="data_validade"
                >
                  <my-date-time
                    v-model="infoOrcamento.data_validade"
                    :readonly="true"
                    :format="'dd/MM/yyyy'"
                    :type="'date'"
                    id="data_validade"
                    :title="'Data de Validade:'"
                  ></my-date-time>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="Previsão de Fechamento"
                  label-for="previsao_fechamento"
                >
                  <b-form-input
                    id="previsao_fechamento"
                    :type="'date'"
                    v-model="infoOrcamento.previsao_fechamento"
                    placeholder="Previsão de Fechamento"
                    @blur="alteraPrevFechamento()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Contato" label-for="contato">
                  <b-form-input
                    id="contato"
                    type="text"
                    v-model="infoOrcamento.contato"
                    :disable="!orcamentoEstaModoEdicao"
                    placeholder="Contato"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <b-form-group label="CNPJ*" label-for="cnpj">
                  <b-form-input
                    id="cnpj"
                    type="text"
                    :value="clientBasicInfo.cnpj | cnpj"
                    placeholder="CNPJ"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="8">
                <b-form-group label="Razão Social" label-for="razao_social">
                  <b-form-input
                    id="razao_social"
                    type="text"
                    :value="clientBasicInfo.razao_social"
                    placeholder="Razão Social"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  v-if="clientStatus != null"
                  label="Status do Cliente"
                  label-for="status"
                >
                  <h3>
                    <cliente-status id="status" :status="clientStatus" />
                  </h3>
                </b-form-group>
              </b-col>
            </b-row>
            <template v-if="!productsVisible">
              <b-row>
                <b-col>
                  <b-card no-body>
                    <b-card-header class="p-2">
                      <i class="icon-list ml-1"></i>
                      <span
                        ><b>{{ getFilial() }}</b></span
                      >
                      <b-button
                        v-if="orcamentoEstaModoEdicao"
                        v-on:click="showProducts"
                        size="sm"
                        class="float-right"
                        variant="primary"
                      >
                        <i class="fa fa-plus"></i> Adicionar Produtos
                      </b-button>
                    </b-card-header>
                    <b-card-body class="orcamento-table-card-body font-12">
                      <span v-show="carregandoItensOrcamento" class="loading-texto">
                        <svg width="40" height="40" viewBox="0 0 50 50">
                          <circle
                            cx="25"
                            cy="25"
                            r="20"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="5"
                            stroke-linecap="round"
                            stroke-dasharray="31.4 31.4">
                            <animateTransform
                              attributeName="transform"
                              type="rotate"
                              from="0 25 25"
                              to="360 25 25"
                              dur="1s"
                              repeatCount="indefinite" />
                          </circle>
                        </svg>
                        Carregando itens...</span>
                      <b-table
                        v-show="!carregandoItensOrcamento"
                        class="w-100 orcamento-footer mb-0"
                        :items="orcamentoItens"
                        :fields="fields"
                        v-on:sort-changed="onSortChanged"
                        small
                        hover
                        bordered
                        :responsive="true"
                        :sort-by.sync="sortBy"
                        :sort-direction.sync="sortDirection"
                        :foot-clone="true"
                        :no-footer-sorting="true"
                        :no-sort-reset="true"
                        stacked="sm"
                        ref="cartTable"
                      >
                        <template #thead-top="">
                          <b-tr>
                            <b-th
                              class="text-center"
                              variant="default"
                              colspan="2"
                            >
                              Informações
                            </b-th>
                            <b-th
                              class="text-center"
                              variant="default"
                              colspan="8"
                            >
                              Valores
                            </b-th>
                            <b-th></b-th>
                          </b-tr>
                        </template>
                        <template v-slot:cell(id)="data">
                          <div class="btn-flex">
                            <b-button
                              v-if="orcamentoEstaModoEdicao"
                              class="my-data-table-row-button"
                              size="sm"
                              variant="primary"
                              v-on:click="editBudgetItem(data.item)"
                            >
                              <i class="fa fa-edit"></i>
                            </b-button>
                            <b-button
                              v-if="orcamentoEstaModoEdicao"
                              class="my-data-table-row-button"
                              size="sm"
                              variant="danger"
                              v-on:click="confirmDeleteItem(data.item)"
                            >
                              <i class="fa fa-trash"></i>
                            </b-button>
                          </div>
                        </template>
                        <template v-slot:cell(titulo)="data">
                          <div class="titulo-produto">
                            <div
                              class="float-left titulo-produto-ellipsis font-12"
                            >
                              {{ data.item.titulo }}
                            </div>
                            <orcamento-item-alerta
                              :key="data.item.id"
                              :id="'orcamentoItemAlertaID' + data.item.id"
                              v-if="orcamentoEstaModoEdicao"
                              class="float-right"
                              :orcamentoId="data.item.orcamento_id"
                              :orcamentoItemId="data.item.id"
                            ></orcamento-item-alerta>
                          </div>
                        </template>
                        <template v-slot:cell(valor_unitario)="data">
                          {{ data.item.valor_unitario | money }}
                        </template>
                        <template v-slot:cell(margem_valor)="data">
                          {{ data.item.margem_valor | money }}
                        </template>
                        <template v-slot:cell(valor_ipi)="data">
                          {{
                            (data.item.valor_ipi + data.item.valor_margem_ipi)
                              | money
                          }}
                        </template>
                        <template v-slot:cell(valor_st)="data">
                          {{
                            (data.item.valor_st + data.item.valor_margem_st)
                              | money
                          }}
                        </template>
                        <template v-slot:cell(valor_bruto_unit)="data">
                          {{
                            (data.item.valor_unitario +
                              data.item.margem_valor +
                              (data.item.valor_ipi +
                                data.item.valor_margem_ipi) +
                              (data.item.valor_st + data.item.valor_margem_st))
                              | money
                          }}
                        </template>
                        <template v-slot:cell(valor_total)="data">
                          {{ data.item.valor_total | money }}
                        </template>
                        <template v-slot:cell(valor_comissao)="data">
                          {{ getValorComissao(data.item) | money }}
                        </template>
                        <template v-slot:foot(titulo)>
                          <div class="w-100" id="info-frete">
                            O frete será pago pela Dicomp somente quando o valor dos 
                            produtos, sem incluir impostos ou premiações,
                            for superior a R$ 2.000,00, exceto para racks e cabos.
                          </div>
                        </template>
                        <template v-slot:foot()>
                          <span class="text-white">-</span>
                        </template>
                        <template v-slot:foot(margem_valor)>Totais:</template>
                        <template v-slot:foot(valor_total)>
                          <div class="w-100 text-right moeda-real" v-if="!itensAlterados">
                            {{ valorTotalSum | money }}
                          </div>
                          <div class="w-100 text-right moeda-real" v-if="itensAlterados">
                         
                            <svg width="20" height="20" viewBox="0 0 50 50">
                          <circle
                            cx="25"
                            cy="25"
                            r="20"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="5"
                            stroke-linecap="round"
                            stroke-dasharray="31.4 31.4">
                            <animateTransform
                              attributeName="transform"
                              type="rotate"
                              from="0 25 25"
                              to="360 25 25"
                              dur="1s"
                              repeatCount="indefinite" />
                          </circle>
                        </svg>
                          </div>
                        </template>
                        <template v-slot:foot(valor_comissao)>
                          <div class="w-100 text-right moeda-real" v-if="!itensAlterados">
                            {{ comissaoSum | money }}
                          </div>
                          <div class="w-100 text-right moeda-real" v-if="itensAlterados">
                        
                            <svg width="20" height="20" viewBox="0 0 50 50">
                          <circle
                            cx="25"
                            cy="25"
                            r="20"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="5"
                            stroke-linecap="round"
                            stroke-dasharray="31.4 31.4">
                            <animateTransform
                              attributeName="transform"
                              type="rotate"
                              from="0 25 25"
                              to="360 25 25"
                              dur="1s"
                              repeatCount="indefinite" />
                          </circle>
                        </svg>
                          </div>
                        </template>
                      </b-table>
                      <div class="d-block w-100 mt-3 d-sm-none">
                        <div class="w-100 border d-flex pt-2 pb-2">
                          <div
                            class="float-left w-40 text-right font-weight-bold pr-2 pl-2"
                          >
                            Valor Total
                          </div>
                          <div class="float-left w-60">
                            <div class="w-100 text-right moeda-real pr-2 pl-2">
                              {{ valorTotalSum | money }}
                            </div>
                          </div>
                        </div>
                        <div class="w-100 border d-flex pt-2 pb-2">
                          <div
                            class="float-left w-40 text-right font-weight-bold pr-2 pl-2"
                          >
                            Comissão Total
                          </div>
                          <div class="float-left w-60">
                            <div class="w-100 text-right moeda-real pr-2 pl-2">
                              {{ comissaoSum | money }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
              <forma-pgto
                :orcamento-modo-edicao="orcamentoEstaModoEdicao"
                v-if="!carregandoItensOrcamento"
              >
              </forma-pgto>
              <hr />
              <b-row>
                <b-col v-if="orcamentoEstaModoEdicao" md="2">
                  <b-button
                    v-on:click="$bvModal.show('cancelConfirm')"
                    class="w-100 mb-2"
                    variant="danger"
                  >
                    <i class="fa fa-times"></i> Cancelar Orçamento
                  </b-button>
                </b-col>
                <b-col></b-col>
                <b-col v-if="hasProductChanges" md="3">
                  <b-button
                    v-on:click="confirmFixProduts"
                    variant="primary"
                    class="w-100 mb-2"
                  >
                    <i class="fa fa-refresh"></i> Atualizar Produtos
                  </b-button>
                </b-col>
                <b-col md="3">
                  <b-button
                    v-on:click="confirmSend"
                    :disabled="!podeEnviar"
                    variant="primary"
                    class="w-100 mb-2"
                  >
                    <i class="fa fa-send"></i> Enviar Pedido
                  </b-button>
                </b-col>
                <b-col md="3">
                  <b-button
                    v-on:click="salvarOrcamento"
                    :disabled="!orcamentoEstaModoEdicao"
                    variant="success"
                    class="w-100 mb-2"
                  >
                    Salvar
                  </b-button>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col md="12">
                  <div class="w-100" id="info-vlMinimo">
                    Para enviar o pedido, o valor mínimo deve ser de R$ 600,00,
                    considerando a Quantidade, o Valor unitário dos produtos e a
                    Margem.
                  </div>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="cancelConfirm"
      title="Atenção"
      buttonSize="sm"
      okVariant="success"
      okTitle="Sim"
      @ok="confirmCancel()"
      cancelVariant="danger"
      cancelTitle="Não"
      @cancel="fechaModalCancel()"
      footerClass="p-2"
      :hideHeaderClose="modal.hideHeaderClose"
      :centered="modal.centered"
    >
      <div class="confirmacao">
        Tem certeza que deseja cancelar Orçamento Nº. {{ orcamento_id }}?
      </div>
      <div class="my-3 form-group">
        <label for="" style="font-weight: bold"
          >Motivo do cancelamento (opcional)</label
        >
        <textarea
          v-model="motivoCancel"
          id="observacao"
          cols="70"
          rows="3"
          maxlength="300"
          placeholder="Escreva sua mensagem aqui"
          class="form-control"
          @keyup="charCount()"
        ></textarea>
        <p>{{ tamRest }} caracteres restante</p>
      </div>
    </b-modal>
    <b-row v-if="productsVisible">
      <b-col md="12">
        <b-card no-body>
          <b-card-header>
            <span> <i class="icon-list" id="topo-lista-produtos"></i> Lista de Produtos </span>
          </b-card-header>
          <b-card-body>
            <product-list
              id="produtosList"
              ref="produtosList"
              :cd_filial="$store.state.orcamento.dados.cd_filial"
              :cliente_codigo="clientBasicInfo.codigo"
              :resultsPerPage="10"
              v-on:onAdd="onAdd"
              v-on:onAddMga="onAddMga"
              v-on:onAddItj="onAddItj"
            >
              <template #segundaColuna>
                <b-btn
                  :variant="getVariant()"
                  class="d-flex justify-content-between align-items-center w-100"
                  v-on:click="hideProducts"
                >
                  <template v-if="!isAdding()">
                    <i class="icons cui-cart mr-1"></i>
                    R$ {{ valorTotalSum | money }}
                    <b-badge class="ml-1" variant="light">{{
                      QtdeTotalSum
                    }}</b-badge>
                  </template>
                  <template v-else>
                    <div class="text-center">
                      <b-spinner
                        variant="secondary"
                        label="Totalizando..."
                        small
                      ></b-spinner>
                    </div>
                  </template>
                </b-btn>
              </template>
              <template #terceiraColuna v-if="QtdeTotalSum > 0">
                <b-btn class="w-100" variant="success" v-on:click="hideProducts"
                  >Mostrar Lista de Produtos</b-btn
                >
              </template>
            </product-list>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <orcamento-item-edit
      ref="orcamentoItemEdit"
      id="orcamentoItemEdit"
      v-model="currentOrcamentoItem"
      v-on:itemSaved="onItemSaved"
      :codigoCliente="$store.state.orcamento.dados.cliente_codigo"
      :idOrcamento="$store.state.orcamento.dados.id"
    ></orcamento-item-edit>
  </div>
</template>

<style>
.loading-steps{
  padding: 4rem;
  gap: 1rem;
  display: grid;
}
.orcamento-table-card-body {
  overflow: scroll;
  overflow-y: hidden;
  overflow-x: auto;
  padding: 0 !important;
  font-size: 12px;
}
.orcamento-footer tfoot,
.orcamento-footer tfoot > tr,
.orcamento-footer tfoot > tr > th {
  border: none;
  font-size: 0.8rem;
}
.orcamento-footer tfoot > tr > th:nth-child(12),
.orcamento-footer tfoot > tr > th:nth-child(13) {
  border: 1px solid #c8ced3;
}
.orcamento-footer tfoot > tr > th:nth-child(11),
.orcamento-footer tfoot > tr > th:nth-child(12),
.orcamento-footer tfoot > tr > th:nth-child(13) {
  text-align: right;
}
.orcamento-table-card-body tbody tr:nth-of-type(odd) .table-success {
  background-color: #cdedd8;
}
.orcamento-table-card-body tbody tr:nth-of-type(even) .table-success {
  background-color: rgba(205, 237, 216, 0.6);
}
.orcamento-table-card-body tbody tr:nth-of-type(odd) .table-info {
  background-color: #d3eef6;
}
.orcamento-table-card-body tbody tr:nth-of-type(even) .table-info {
  background-color: rgba(211, 238, 246, 0.6);
}
.orcamento-table-card-body tfoot tr th {
  background-color: white;
}
.orcamento-table-card-body tfoot tr:last-child th:hover {
  background-color: white;
}
.btn-flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.titulo-produto {
  display: flex;
  justify-content: space-between;
}
.titulo-produto-ellipsis {
  max-width: 20em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
#info-frete {
  color: red;
  font-weight: 500;
  text-wrap: balance;
}

#info-vlMinimo {
  color: blue;
  font-weight: 600;
}

.font-12 {
  font-size: 12px !important;
}

.icone-observacao {
  border: none !important;
  background: none !important;
  color: #3131bb;
}

.div-oberervacao {
  width: 95% !important;
  margin-left: 2%;
  margin-bottom: 2%;
}

.sem-borda:focus {
  border: none;
}

.btn-primary {
  background-color: #0075eb !important;
}

.btn-warning {
  background-color: #ff6d13 !important;
  color: #fff !important;
}

.loading-texto{
  font-size: 30px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2222222e;
  font-weight: bold;
}

.updatebutton{
  display: flex;
  gap: 0.4rem;
  justify-content: center;
  background: #000;
  color: #fff;
  border-radius: 7px;
  margin-top: 4px;
  cursor: pointer;
  margin: auto;
  width: 100%;
}
.size-6{
  width: 18px;
  margin:0;
}
</style>

<script>
import "../../../assets/css/DataTableRowButton.css";
import Orcamento from "../../../services/orcamento";
import Cliente from "../../../services/cliente";
import ClienteStatus from "../clientes/ClienteStatus";
import OrcamentoStatus from "./OrcamentoStatus";
import OrcamentoItemEdit from "./OrcamentoItemEdit";
import OrcamentoItemAlerta from "./OrcamentoItemAlerta";
import Pedido from "../../../services/pedido";
import MyDateTime from "../../../components/ui/MyDateTime";
import ProductList from "../produtos/ProductList";
import { EventBus } from "../../../helpers/eventBus";
import FormaPgto from "../FormaPgto";
import GrupoPermissao from "../../../services/grupoPermissao";
import ValidadorOrcamento from "../../../services/validadores/validadorOrcamento";

const VALOR_MINIMO_FORMA_PGTO = 250;

export default {
  name: "Orcamento",
  components: {
    ClienteStatus,
    OrcamentoStatus,
    OrcamentoItemEdit,
    OrcamentoItemAlerta,
    MyDateTime,
    ProductList,
    FormaPgto,
  },
  data: () => ({
    loadingSteps: [
      { key: 'orcamento', label: 'Carregando orçamento', done: false },
      { key: 'itens', label: 'Carregando itens do orçamento', done: false },
      { key: 'imposto', label: 'Carregando impostos e margem', done: false },
      { key: 'cliente', label: 'Carregando dados do cliente', done: false },
    ],
    loadingProcess: false,
    itensAlterados: false,
    infoOrcamento: {},
    resp: "",
    productChangesReturned: 0,
    productsReturn: [],
    hasProductChanges: false,
    productsVisible: false,
    valida: false,
    show: false,
    adding: [],
    sortBy: "produto_codigo",
    exibe_observacao: false,
    sortDirection: "asc",
    contato: null,
    orcamento: new Object(),
    orcamentoItens: [],
    currentOrcamentoItem: new Object(),
    orcamento_id: null,
    clientBasicInfo: new Object(),
    tamRest: 300,
    motivoCancel: "",
    valorTotal: 0,
    vlMinimoOrcamento: 0,
    fields: [
      {
        key: "produto_codigo",
        label: "Cód.",
        sortable: true,
        tdClass: "text-right",
        thClass: "text-center",
      },
      { key: "titulo", label: "Descrição", sortable: true },
      {
        key: "quantidade",
        label: "Qtde.",
        sortable: true,
        tdClass: "text-right",
        thClass: "text-center",
      },
      {
        key: "valor_unitario",
        label: "Vl.Unit. S/ ipi",
        sortable: true,
        tdClass: "text-right moeda-real-div",
        thClass: "text-center",
      },
      {
        key: "margem_valor",
        label: "Margem Unit.",
        sortable: true,
        tdClass: "text-right moeda-real-div",
        thClass: "text-center",
      },
      {
        key: "valor_ipi",
        label: "Valor Ipi Unit.",
        sortable: true,
        tdClass: "text-right moeda-real-div",
        thClass: "text-center",
      },
      {
        key: "valor_st",
        label: "Valor St Unit.",
        sortable: true,
        tdClass: "text-right moeda-real-div",
        thClass: "text-center",
      },
      {
        key: "valor_bruto_unit",
        label: "Valor Venda Unitário",
        sortable: true,
        tdClass: "text-right moeda-real-div",
        thClass: "text-center",
      },
      {
        key: "valor_total",
        label: "Valor Venda Total",
        sortable: true,
        tdClass: "text-right moeda-real-div",
        thClass: "text-center",
      },
      {
        key: "valor_comissao",
        label: "Prêmio",
        sortable: true,
        tdClass: "text-right moeda-real-div",
        thClass: "text-center",
      },
      {
        key: "id",
        label: "Ações",
        sortable: false,
        tdClass: "text-center",
        visible: true,
        thClass: "text-center",
      },
    ],
    modal: {
      hideHeaderClose: false,
      centered: true,
    },
    carregandoItensOrcamento: false
  }),
  computed: {
    orcamentoEstaModoEdicao() {
      return this.$store.state.orcamento.dados.status == "D" || this.$store.state.orcamento.dados.status == "S";
    },
    podeEnviar() {
      return (
        !this.hasProductChanges &&
        this.orcamentoItens.length == this.productChangesReturned &&
        this.vlMinimoOrcamento >= 600
      );
    },
    podeImprimirOrcamento() {
      return (
        this.$store.state.orcamento.dados.status != "C" ||
        !this.valida ||
        !this.hasProductChanges
      );
    },
    valorTotalSum() {
      let valorTotal = this.orcamentoItens.reduce(function (total, item) {
        return total + item.valor_total * 1;
      }, 0);

      if(this.orcamentoItens.length > 0 && this.$store.state.orcamento.valorTotal != valorTotal){
        this.$store.commit('orcamento/ATUALIZAR_VALOR_TOTAL', valorTotal);
        EventBus.$emit("eventoAtualizarPagamento", true);
      }

      return valorTotal;
    },
    QtdeTotalSum() {
      return this.orcamentoItens.reduce(function (total, item) {
        return total + item.quantidade * 1;
      }, 0);
    },
    comissaoSum() {
      let vue = this;
      const somaTotal = this.orcamentoItens.reduce(function (total, item) {
        return total + vue.getValorComissao(item);
      }, 0);
      return somaTotal 
    },
    clientStatus() {
      return this.clientBasicInfo.status;
    },
    orcamentoStatus() {
      return this.orcamento.status;
    },
  },
  beforeMount() {
    this.validaPermissao();
    this.orcamento_id = this.$route.params.id;
    this.loadBudget(this.orcamento_id);

    let vue = this;

    EventBus.$on("onBudgetItemHasChanges", (item) => {
      let index = vue.productsReturn.findIndex(
        (el) => el == item.orcamento_item_id
      );
      if (index == -1) {
        vue.productChangesReturned++;
      }
      vue.productsReturn.push(item.orcamento_item_id);
      if (item.changed) vue.hasProductChanges = true;
    });

    EventBus.$on("sendOrcamento", this.sendOrcamento);

    EventBus.$emit("finishLoad", {
      finish: false,
    });

    window.onbeforeunload  =  function(){
      if (vue.$store.state.ui.salvandoPedido) {
        return "";
      }
    }

    ValidadorOrcamento.setarConfiguracao(this.$helper, this.$bvModal);
  },
  methods: {
    markStep(key) {
      const step = this.loadingSteps.find(s => s.key === key);
      if (step) step.done = true;
    },
    atualizarInfoOrcamento(){
      for(let campo in this.infoOrcamento){
        let dado = {};
        dado[campo] = this.infoOrcamento[campo];
        this.$store.commit('orcamento/SALVAR_DADO_ORCAMENTO', dado);
      }
    },
    validaPermissao() {
      GrupoPermissao.getPermissao("/vendas/orcamentos").then((response) => {
        if (!response.data.data || response.data.data.edita != "1")
          this.$router.push("/");
      });
    },
    async showHideColumnId() {
      {
        let index = this.fields.findIndex((x) => x.key == "id");
        if (!this.orcamentoEstaModoEdicao) {
          this.$set(this.fields, index, {
            key: "id",
            label: "Ações",
            sortable: false,
            thClass: "d-none",
            tdClass: "d-none",
          });
        } else {
          this.$set(this.fields, index, {
            key: "id",
            label: "Ações",
            sortable: false,
            thClass: null,
            tdClass: "text-center",
          });
        }
      }
    },
    async loadBudget(id) {
      
      this.loadingProcess = true;
      this.loadingSteps.forEach(s => s.done = false);
      
      this.orcamento = new Object();
     try {
       const [_, response] = await Promise.all([this.loadOrcamentoItens(id), Orcamento.getByCodigo(id)])
       this.markStep('itens');
       this.markStep('orcamento');

       this.$store.commit("orcamento/SALVAR_ORCAMENTO", response.data.data);
       this.$store.commit("orcamento/SALVAR_ORCAMENTO_ORIGINAL", Object.assign({}, response.data.data));
       this.infoOrcamento.data_validade = response.data.data.data_validade;
       this.infoOrcamento.previsao_fechamento = response.data.data.previsao_fechamento;
       this.infoOrcamento.contato = response.data.data.contato;

        await this.loadClientBasicInfo(this.$store.state.orcamento.dados.cliente_codigo);
        this.markStep('cliente');
        this.showHideColumnId();
           if (this.$store.state.orcamento.dados.cd_filial == 1) {
             this.$store.commit(
               "carrinho/CURRENT_CLIENT",
               this.orcamento.cliente_codigo
             );
           } else {
             this.$store.commit(
               "carrinhoitj/CURRENT_CLIENT_ITJ",
               this.orcamento.cliente_codigo
             );
           }
           
           this.markStep('imposto');
        } catch (e) {
            this.$helper.showErrorResponse(e);
        }
        finally {
        this.loadingProcess = false;
      }
    },
    async loadOrcamentoItens(orcamento_id) {
      if (orcamento_id == null || orcamento_id == 0) return;
      this.productChangesReturned = 0;

      try {
        const response = await Orcamento.getOrcamentoItens(orcamento_id)
          
            this.orcamentoItens = response.data.data;
  
            this.orcamentoItens.forEach((el) => {
              el.ultimaMargem = {
                margemValor: el.margem_valor,
                margemPercentual: el.margem_percentual,
              };
            });
  
            if(this.orcamentoItens.length > 0){
              this.setarTabelapreco(this.orcamentoItens[0].cd_tabelapreco);
            }
  
            this.vlMinimoOrcamento = response.data.valor_unitario_total;
  
            this.validaBot(this.orcamentoItens);  
      } catch (e) {
        if (e.response.status === 404) {
          this.productsVisible = true;
          return;
        }
        this.$helper.showErrorResponse(e);
      }
      finally{
          this.carregandoItensOrcamento = false;
        };
    },
    validaBot(value) {
      for (let i = 0; i < value.length; i++) {
        let valor_unit =
          value[i].valor_unitario +
          value[i].margem_valor +
          value[i].valor_ipi +
          value[i].valor_st;
        if (value[i].bo_registro == "false") {
          if (
            value[i].vl_liquido_tab_coorp != 0 &&
            value[i].vl_liquido_tab_coorp > valor_unit
          ) {
            this.valida = true;
          }
        }
        this.show = true;
      }
    },
    async loadClientBasicInfo(cliente_codigo) {
      if (cliente_codigo == null || cliente_codigo == 0) return;
      this.clientBasicInfo = new Object();
      
      const response = await Cliente.getBasicInfo(cliente_codigo)
      try {
        this.clientBasicInfo = response.data.data;
        this.$store.state.orcamento.dados.pessoaFisica = response.data.data.cnpj.length === 11;
      } catch (e) {
        this.$helper.showErrorResponse(e);     
      }  
    },
    charCount() {
      this.tamRest = 300 - this.motivoCancel.length;
    },
    onSortChanged() {},
    confirmDeleteItem(row) {
      this.$bvModal
        .msgBoxConfirm(
          "Tem certeza que deseja excluir o produto Nº." +
            row.produto_codigo +
            "?",
          {
            title: "Atenção",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Sim",
            cancelTitle: "Não",
            footerClass: "p-2",
            hideHeaderClose: this.modal.hideHeaderClose,
            centered: this.modal.centered,
          }
        )
        .then((value) => {
          if (value) {
            let vue = this;
            Orcamento.deleteOrcamentoItem(row.orcamento_id, row.id)
              .then((response) => {
                this.$helper.showMsg(response.data.msg, response.data.type);
                let index = vue.orcamentoItens.findIndex((x) => x.id == row.id);
                vue.orcamentoItens.splice(index, 1);

                vue.productChangesReturned = 0;
                let list = [];

                vue.productsReturn.forEach((value, index) => {
                  if (value == row.id) {
                    vue.productsReturn.splice(index, 1);
                  }

                  if (
                    list.findIndex((item) => item == value) == -1 &&
                    value != row.id
                  ) {
                    list.push(value);
                  }
                });
                vue.productChangesReturned = list.length;
              })
              .catch((e) => {
                this.$helper.showErrorResponse(e);
              });
          }
        })
        .catch((err) => {
          this.$helper.showErrorResponse(err);
        });
    },
    confirmCancel() {
      Orcamento.cancelOrcamento(this.$store.state.orcamento.dados.id, this.motivoCancel)
        .then((response) => {
          this.$helper.showMsg(response.data.msg, response.data.type);
          this.$router.push("/vendas/orcamentos");
        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        });
    },
    fechaModalCancel() {
      this.tamRest = 300;
      this.motivoCancel = "";
      $bvModal.hide("cancelConfirm");
    },
    confirmFixProduts() {
      this.$bvModal
        .msgBoxConfirm(
          "Tem certeza que atualizar os produtos do Orçamento Nº. " +
            this.$store.state.orcamento.dados.id +
            "?",
          {
            title: "Atenção",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "Sim",
            cancelVariant: "danger",
            cancelTitle: "Não",
            footerClass: "p-2",
            hideHeaderClose: this.modal.hideHeaderClose,
            centered: this.modal.centered,
          }
        )
        .then((value) => {
          if (value) {
            this.$store.commit('ui/LOADING', true);
            Orcamento.updateProducts(this.$store.state.orcamento.dados.id)
              .then((response) => {
                this.hasProductChanges = false;
                this.loadOrcamentoItens(this.$store.state.orcamento.dados.id);
                this.$helper.showMsg(response.data.msg, response.data.type);
                this.productsReturn.splice(0, this.productsReturn.length);
              })
              .catch((e) => {
                this.$helper.showErrorResponse(e);
              })
              .finally(() => {
                this.$store.commit('ui/LOADING', false);
              })
              ;
          }
        })
        .catch((err) => {
          this.$helper.showErrorResponse(err);
        });
    },
    getValorComissao(item) {
      return item.valor_comissao;
    },
    async confirmSend() {
      let statusCliente = this.clientBasicInfo.status;
      let orcamento = this.$store.state.orcamento.dados;
      let orcamentoOriginal = this.$store.state.orcamento.dadosOriginais;
      let itens = this.orcamentoItens;
      let ehValido = await ValidadorOrcamento.validarEnvioOrcamento(statusCliente, orcamento, itens, this.infoOrcamento, orcamentoOriginal)

      if(ehValido) {
        this.$bvModal
          .msgBoxConfirm(
            "Tem certeza que deseja enviar Orçamento Nº. " +
              orcamento.id +
              ", depois de enviado não será mais possível alterá-lo?",
            {
              title: "Atenção",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              okTitle: "Sim",
              cancelVariant: "danger",
              cancelTitle: "Não",
              footerClass: "p-2",
              hideHeaderClose: this.modal.hideHeaderClose,
              centered: this.modal.centered,
            }
          )
          .then((value) => {
            if (value) {
              this.sendOrcamento();
            }
          })
          .catch((err) => {
            this.$helper.showErrorResponse(err);
          })
      }
    },
    getVariant() {
      return this.$store.state.orcamento.dados.cd_filial == 1 ? "primary" : "warning";
    },
    getFilial() {
      return this.$store.state.orcamento.dados.cd_filial == 1 ? "Maringá - PR" : "Itajaí - SC";
    },
    permiteInserirOuEditarItem(){
      let dadosParaValidacao = {id_forma: this.$store.state.orcamento.dadosOriginais.id_forma, id_condicao: this.$store.state.orcamento.dadosOriginais.id_condicao};
      dadosParaValidacao = Object.assign(dadosParaValidacao, this.infoOrcamento);

      return ValidadorOrcamento.existeAlteracoesNaoSalvas(this.$store.state.orcamento.dados, dadosParaValidacao) ? false : true;
    },
    salvarOrcamento() {
      let orcamento = this.$store.state.orcamento.dados;
    
      if(this.orcamentoEstaModoEdicao && ValidadorOrcamento.existeAlteracoesNaoSalvas(orcamento, this.infoOrcamento)){
        this.atualizarInfoOrcamento();
      }

      Orcamento.saveOrcamento(orcamento, this.$store.state.orcamento.dados.cd_filial)
        .then((response) => {
          this.$helper.showMsg(response.data.msg);
          this.$store.commit("orcamento/SALVAR_ORCAMENTO_ORIGINAL", Object.assign({}, orcamento));
        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        });
    },
    sendOrcamento() {
      let data = {
        orcamento: this.$store.state.orcamento.dados,
        itens: this.orcamentoItens,
        cd_filial: this.$store.state.orcamento.dados.cd_filial,
        valor_total: this.valorTotalSum,
      };

      this.$store.commit('ui/LOADING_MSG', "Enviando Pedido de Venda…");

      const pedidoData = Pedido.criarPedidoData(data)

      Orcamento.sendOrcamento(this.$store.state.orcamento.dados.id, pedidoData)
        .then((response) => {
          this.$helper.showMsg('Pedido enviado com sucesso!', 'success');
          this.$router.push("/vendas/orcamentos");

        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        }).finally(() => {
          this.$store.commit('ui/LOADING_MSG', "");
          this.$store.commit('ui/SALVANDO_PEDIDO', false);
        });
    },
    salvarPedido() {
      let data = {
        orcamento: this.$store.state.orcamento.dados,
        itens: this.orcamentoItens,
        cd_filial: this.$store.state.orcamento.dados.cd_filial,
        valor_total: this.valorTotalSum,
      };

      Pedido.salvePedido(data)
      .then((response) => {
        this.$helper.showMsg('Pedido enviado com sucesso!', 'success');
        this.$router.push("/vendas/orcamentos");
      })
      .catch((e) => {
        this.$helper.showErrorResponse('');
      })
      .finally(() => {
        this.$store.commit('ui/SALVANDO_PEDIDO', false);
      });
    },
    async editBudgetItem(item) {
      if(this.valorTotalSum >= VALOR_MINIMO_FORMA_PGTO && !this.permiteInserirOuEditarItem()){
        let continuar = await this.confirmarSeProssegueAcao();

        if(!continuar){
          return;
        }
      }

      this.currentOrcamentoItem = Object.assign({}, item);
      this.$bvModal.show(this.$refs.orcamentoItemEdit.id);
    },
    async onItemSaved(item) {
      this.itensAlterados = true;
      await this.loadOrcamentoItens(this.orcamento_id)
      this.itensAlterados = false;
    },
    printOrcamento() {
      this.$store.commit('ui/LOADING_MSG', "Gerando proposta do orçamento...");
      Orcamento.printOrcamento(this.$store.state.orcamento.dados.id)
        .then((response) => {
          let fileURL = window.URL.createObjectURL(
            new Blob([response.data], {
              type: "application/pdf",
            })
          );
          let windowPrint = window.open(fileURL, "about:blank");
          if(!windowPrint || windowPrint.closed || typeof windowPrint.closed=='undefined') 
          { 
            return this.$toast.error({
                        message: "Seu navegador bloqueou uma janela pop-up. Para continuar, por favor, permita pop-ups para este site.",
                        showMethod: 'swing',
                        timeOut: 8000,
                        progressBar: true,
                        errorColor: '#dc3545'});
          };
          windowPrint.onload = function () {
            windowPrint.print();
          };
        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        }).finally(() => {
          this.$store.commit('ui/LOADING_MSG', "");
        })
    },
    isAdding(produto_codigo = null) {
      if (produto_codigo == null) return this.adding.length > 0;
      else return this.adding.includes(produto_codigo);
    },
    onAddMga(data) {
      this.onAdd(data);
    },
    onAddItj(data) {
      this.onAdd(data);
    },
    onAdd(data) {
      this.onStartAdding(data.codigo);
      let addItem = {
        produto_codigo: data.codigo,
        quantidade: data.quantidade,
        cd_filial: this.$store.state.orcamento.dados.cd_filial,
        cd_empresa: 1,
      };
      Orcamento.addOrcamentoItem(this.$store.state.orcamento.dados.id, addItem)
        .then((response) => {
          let newItem = response.data.data;
          newItem.titulo = data.titulo;
          newItem.valor_bruto_unit =
            newItem.valor_unitario * 1 +
            newItem.valor_ipi * 1 +
            newItem.valor_st * 1 +
            newItem.margem_valor * 1;
          newItem.valor_total =
            newItem.quantidade * 1 * newItem.valor_bruto_unit;
          let index = this.orcamentoItens.findIndex((x) => x.id == newItem.id);
          if (index > -1) {
            this.$set(this.orcamentoItens, index, newItem);
          } else {
            this.orcamentoItens.push(newItem);
          }
        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        })
        .finally(() => {
          this.onEndAdding(data.codigo);
        });
    },
    onStartAdding(produto_codigo) {
      this.adding.push(produto_codigo);
    },
    onEndAdding(produto_codigo) {
      this.adding = this.adding.filter(function (value) {
        return value != produto_codigo;
      });
    },
    async showProducts() {
      if(this.valorTotalSum >= VALOR_MINIMO_FORMA_PGTO && !this.permiteInserirOuEditarItem()){
        let continuar = await this.confirmarSeProssegueAcao();

        if(!continuar){
          return;
        }
      }

      this.$store.state.carrinho.cliente_codigo = this.$store.state.orcamento.dados.cliente_codigo;
      this.productsVisible = true;
    },
    hideProducts() {
      location.reload();
      this.productsVisible = false;
    },
    async confirmarSeProssegueAcao(){
      return await this.$bvModal.msgBoxConfirm(
                        "Existem campos obrigatórios não preenchidos. Se continuar, você poderá perder dados não salvos. Deseja prosseguir?",
                        {
                        title: "Atenção",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        okTitle: "Sim",
                        cancelVariant: "danger",
                        cancelTitle: "Não",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true
                       }
        );
    },
    alteraPrevFechamento() {
      const data_prev = new Date(this.infoOrcamento.previsao_fechamento);
      const data_atual = new Date();
      data_atual.setUTCHours(0, 0, 0, 0);
      if (data_prev.getTime() < data_atual.getTime()) {
        this.$helper.showMsg(
          "A data de previsão de fechamento não pode ser menor que a data atual.",
          "warning"
        );
        return;
      }
    },   
    duplicarOrcamento() {
      Orcamento.duplicarOrcamento(this.$store.state.orcamento.dados)
        .then((response) => {
          this.$helper.showMsg(response.data.msg, response.data.type);
        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        });
    },
    setarTabelapreco(cd_tabelapreco){
      if(!this.infoOrcamento.cd_tabelapreco){
        this.infoOrcamento.cd_tabelapreco = cd_tabelapreco;
      }
      
    }
  },
  beforeDestroy() {
    EventBus.$off("sendOrcamento", this.sendOrcamento);
  },
};
</script>
